module.exports = __webpack_public_path__ + "static/media/lato-black.dbb62027.woff";